import { GridCellProps } from '@progress/kendo-react-grid';
import { format } from 'date-fns';
import { isEmpty } from 'lodash';
import { useMemo } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import { useContextSelector } from 'use-context-selector';
import { ViewCatalogProductsContext } from '../ViewCatalogProductsContext';

const LastPurchaseDateCell = (props: GridCellProps) => {
  const { value } = useGridCellDisplayValue(props);

  const displayValue = useMemo(() => {
    try {
      if (isEmpty(value)) return '';
      return format(new Date(value as string), 'Ppp').replace(', ', ' ');
    } catch (error) {
      return '';
    }
  }, [value]);

  const selectedCatalog = useContextSelector(
    ViewCatalogProductsContext,
    (context) => context.selectedCatalog
  );
  const isExternalSupplier = !!(selectedCatalog && selectedCatalog?.catalogType === 2);

  return (
    <GridCellBase
      {...props}
      rowSelectionEnabled={isExternalSupplier ? false : true}
      className="!p-0"
      title={displayValue}
    >
      <span>{displayValue}</span>
    </GridCellBase>
  );
};

export default LastPurchaseDateCell;
